/**
 * Grid Loading State Component
 * Displays skeleton rows while data is loading
 */

import { Skeleton } from '@/core/components/ui/skeleton';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/core/components/ui/table';

interface GridLoadingStateProps {
  rowCount?: number;
  columnCount?: number;
}

export const GridLoadingState = ({
  rowCount = 10,
  columnCount = 8,
}: GridLoadingStateProps) => {
  const columns = [
    'Location ID',
    'Session ID',
    'Actor Hierarchy',
    'Location Name',
    'Start Time',
    'Stop Time',
    'Total Energy',
    'Settlement Value',
  ].slice(0, columnCount);

  return (
    <div className="w-full space-y-4">
      {/* Header skeleton */}
      <div className="flex items-center justify-between px-2">
        <Skeleton className="h-5 w-32" />
        <Skeleton className="h-8 w-8 rounded-md" />
      </div>

      {/* Table skeleton */}
      <div className="border rounded-md">
        <Table>
          <TableHeader>
            <TableRow className="bg-gray-50">
              {columns.map((header, index) => (
                <TableHead key={index} className="text-xs font-medium text-gray-700">
                  {header}
                </TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody>
            {Array.from({ length: rowCount }).map((_, rowIndex) => (
              <TableRow key={rowIndex}>
                {columns.map((_, cellIndex) => (
                  <TableCell key={cellIndex} className="py-3">
                    <Skeleton className="h-4 w-full" />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};
